import { useLocation } from 'react-router-dom'
import { Navigate } from 'react-router-dom-v5-compat'

// Keep saved notification links and bookmarks within the current router scope.
export function InboxRedirect() {
  const location = useLocation()
  return <Navigate to={{ pathname: '/inbox/', search: location.search, hash: location.hash }} replace />
}
